export function rssiStrength(rssi) {
  if (rssi >= -60) return 3;
  if (rssi >= -72) return 2;
  return 1;
}
